import { Component,  Output, EventEmitter,  OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Company } from '../models/Compnany';
import { CostCenter } from '../models/CostCenter';
import { CreateKaizen } from '../models/Kaizen';
import { KaizenImpactingModel } from '../models/KaizenImpactingModel';
import { Line } from '../models/Line';
import { Shop } from '../models/Shop';
import { VehicleModel } from '../models/VehicleModel';
import { CompanyService } from '../Services/Company.Service';
import { CostCenterService } from '../Services/CostCenter.Services';
import { KaizenService } from '../Services/Kaizen.Service';
import { KaizenImpactingModelService } from '../Services/KaizenImpactingModel.Services';
import { LineService } from '../Services/Line.Services';
import { ShopService } from '../Services/Shop.Services';
import { VehicleModelService } from '../Services/VehicleModel.Services';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
@Component({
    selector: 'app-location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.css'],
    standalone: false
})
export class LocationComponent implements OnInit {
  CreateKaizenLocation: CreateKaizen = new CreateKaizen();
    // @Input() kaizenId: number = 0;
   @Output() emitKaizenLocation: EventEmitter<CreateKaizen> = new EventEmitter<CreateKaizen>();
  shopControl = new UntypedFormControl();
  constructor(private kaizenImpactingModelService: KaizenImpactingModelService, private CompanyService: CompanyService,
    private ShopService: ShopService, private LineService: LineService, private CostCenterService: CostCenterService,
    private vehicleModelService: VehicleModelService, private formBuilder: UntypedFormBuilder, private KaizenService: KaizenService,
    private route: ActivatedRoute) 
    {
        this.filteredShops = this.shopControl.valueChanges.pipe
        (
          startWith(''),
          debounceTime(400),
          distinctUntilChanged(),
          switchMap(val => {
            return this.filter((val || ''),'')
          })
        );
    }
 


  formLocation!: UntypedFormGroup;
 
  kaizenImpactingModel !: KaizenImpactingModel[];
  selectedGLAccountImpactArea: number = 0;
  filteredVehicleModels !: VehicleModel[];
  filteredSupportingcostCenters !: CostCenter[];
  costCenters !: CostCenter[];
  filteredCostCenters !: CostCenter[];
  companies!: Company[];
  shops!: Shop[];
  filteredKaizenLeader!: Observable<Shop[]>;
  filteredShops !: Observable<Shop[]>;
  filteredSupportingShops !: Shop[];
  lines!: Line[];
  filteredLines!: Line[];
  filteredSupportingLines!: Line[];
  vehicleModel !: VehicleModel[];
  filteredVehicleModel !: VehicleModel[];
  editKaizen: CreateKaizen = new CreateKaizen();
  requiredLegend: string = '* = required field';
  kaizenId: number = 0;
  selectedCompanyId: number = 0;  
  public shop?: Shop;
  allCompanies!: Company[];

  ngOnInit(): void 
  {
    this.kaizenId = Number(this.route.snapshot.paramMap.get('id'));
    this.initiateDD();
    this.formLocation = this.formBuilder.group({
      companyID: [''],
      supportingCompanyId: [''],
      lineId: [''],
      supportingLineId: [''],
      shopControl: [''],
      supportingShopId: [''],
      costCenterID: [''],
      supportingCostCenterID: [''],
      modelId: [''],
      kaizenImpactingModelId: ['']
    });
    

    this.shopControl.valueChanges.subscribe((shopname: string) => 
    {
      this.CreateKaizenLocation.shopName = shopname;
      if (shopname != null)
      {   
          
        this.CreateKaizenLocation.shopID = this.shops.find(x => x.name === shopname)?.shopID ?? -1;
        if(this.CreateKaizenLocation.shopID > 0)
        {
          this.CreateKaizenLocation.lineID =  this.shops.find(x => x.shopID === this.CreateKaizenLocation.shopID)?.lineID ?? 1;  
          this.formLocation.controls['lineId'].setValue(this.CreateKaizenLocation.lineID);
          this.formLocation.controls['lineId'].disable();
          this.filteredVehicleModels = this.vehicleModel.filter(x => x.lineID == this.CreateKaizenLocation.lineID);

          firstValueFrom(this.CostCenterService.getCostCenterByShopId(this.CreateKaizenLocation.shopID)).then((data) => 

          { this.filteredCostCenters = data?.data || [];
            this.costCenters = data?.data || [];
          });
        }
       
      }
      else
      {
        this.filteredLines = [];
      }
      
      this.emitLocation();
    });
  }
 
  initiateDD = async () => {
    await firstValueFrom(this.CompanyService.getCompanies()).then((data) => {
      this.allCompanies = data?.data || [];
      const compId = localStorage.getItem("companyId");
      const role = localStorage.getItem("adroleNormalized");
      if (role == 'ISAdmin' || role == 'SystemAdmin') {

        this.companies = this.allCompanies;
      }
      else {
        this.companies = this.allCompanies.filter(x => x.companyID.toString() == compId);
      }
    });
    await firstValueFrom(this.kaizenImpactingModelService.getKaizenImpactingModels()).then((data) => { this.kaizenImpactingModel = data?.data || [] });
    await firstValueFrom(this.vehicleModelService.getVehicleModels()).then((data) => { this.vehicleModel = data?.data || [] });

    this.formLocation.controls['modelId'].disable();

    if (this.kaizenId != 0) {

      firstValueFrom(this.KaizenService.getKaizen(this.kaizenId)).then((data) => {
        this.editKaizen = data?.data ?? new CreateKaizen();
        this.editKaizen.locTabUpdateFlag = false;
       this.selectedCompanyId = this.editKaizen.companyID;
       firstValueFrom(this.ShopService.getNonSupportShopByCompanyId(this.editKaizen.companyID)).then((data) => 
        { 
          this.shops = data?.data || []; 
          this.filteredVehicleModels = this.vehicleModel.filter(x => x.lineID == this.editKaizen.lineID);
          this.CreateKaizenLocation.shopName = '' + this.shops.find(x => x.shopID == this.editKaizen.shopID)?.name;
          this.shopControl.setValue(this.CreateKaizenLocation.shopName);

          this.filteredShops = this.shopControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
            switchMap(val => {
              return this.filter((val || ''),'')
            })
          );

          firstValueFrom(this.LineService.getNonSupportLineByCompanyId(this.editKaizen.companyID)).then((data) => 
          { 
            this.lines = data?.data || []; 
            this.filteredLines = data?.data || []; 
            this.CreateKaizenLocation.lineName = '' + this.lines.find(x => x.lineID == this.editKaizen.lineID)?.lineName;
            this.formLocation.controls['lineId'].setValue(this.editKaizen.lineID);
          });
          firstValueFrom(this.CostCenterService.getCostCenterByShopId(this.editKaizen.shopID)).then((data) => 
            { 
              this.costCenters = data?.data || []; 
              this.filteredCostCenters = data?.data || []; 
            this.formLocation.controls['costCenterID'].setValue(this.editKaizen.costCenterID);
              
            });
        });
       

        if (this.editKaizen.supportingCompanyID != null) {
          firstValueFrom(this.LineService.getNonSupportLineByCompanyId(this.editKaizen.supportingCompanyID)).then((data) => {
            this.filteredSupportingLines = data?.data || [];
          });
        }
        if (this.editKaizen.supportingLineID != null) {
          firstValueFrom(this.ShopService.getShopByLineId(this.editKaizen.supportingLineID)).then((data) => {
            this.filteredSupportingShops = data?.data || [];
          });
        }
        if (this.editKaizen.supportingShopID != null) {
          firstValueFrom(this.CostCenterService.getCostCenterByShopId(this.editKaizen.supportingShopID)).then((data) => {
            this.filteredSupportingcostCenters = data?.data || [];
          });
        }
        this.CreateKaizenLocation.companyID = this.editKaizen.companyID;
        this.CreateKaizenLocation.lineID = this.editKaizen.lineID;
        this.CreateKaizenLocation.shopID = this.editKaizen.shopID;
        this.CreateKaizenLocation.vehicleModelID = this.editKaizen.vehicleModelID;
        
        this.CreateKaizenLocation.kaizenImpactingModelID = this.editKaizen.kaizenImpactingModelID;
        this.CreateKaizenLocation.supportingCompanyID = this.editKaizen.supportingCompanyID;
        this.CreateKaizenLocation.supportingShopID = this.editKaizen.supportingShopID;
        this.CreateKaizenLocation.supportingLineID = this.editKaizen.supportingLineID;
        this.CreateKaizenLocation.supportingCostCenterID = this.editKaizen.supportingCostCenterID;
        if (this.editKaizen.supportingCompanyID != null) {
          this.formLocation.controls['supportingCompanyId'].setValue(this.editKaizen.supportingCompanyID);
        }
        if (this.editKaizen.supportingLineID != null) {
          this.formLocation.controls['supportingLineId'].setValue(this.editKaizen.supportingLineID);
        }
        if (this.editKaizen.supportingShopID != null) {
          this.formLocation.controls['supportingShopId'].setValue(this.editKaizen.supportingShopID);
        }
        
        if (this.editKaizen.costCenterID != null) {
          this.formLocation.controls['costCenterID'].setValue(this.editKaizen.costCenterID);
        }
        if (this.editKaizen.supportingCostCenterID != null) {
          this.formLocation.controls['supportingCostCenterID'].setValue(this.editKaizen.supportingCostCenterID);
        }
        if (this.editKaizen.vehicleModelID != null) {
          this.formLocation.controls['modelId'].setValue(this.editKaizen.vehicleModelID);
          this.formLocation.controls['modelId'].enable();         
        }
        else
        {
          this.formLocation.controls['modelId'].disable();
          this.formLocation.controls['modelId'].setValue('');  
        }
        this.CreateKaizenLocation.costCenterID = this.editKaizen.costCenterID;
        this.formLocation.controls['companyID'].setValue(this.editKaizen.companyID);  
        this.formLocation.controls['lineId'].setValue(this.editKaizen.lineID);
        this.formLocation.controls['costCenterID'].setValue(this.editKaizen.costCenterID);
        this.formLocation.controls['kaizenImpactingModelId'].setValue(this.editKaizen.kaizenImpactingModelID);
        this.CreateKaizenLocation.companyName = '' + this.companies.find(x => x.companyID == this.editKaizen.companyID)?.companyName;
        this.CreateKaizenLocation.vehicleModel = '' + this.vehicleModel.find(x => x.vehicleModelID == this.editKaizen.vehicleModelID)?.modelName;
        this.CreateKaizenLocation.impactingModel = '' + this.kaizenImpactingModel.find(x => x.kaizenImpactingModelID == this.editKaizen.kaizenImpactingModelID)?.name;        
      });
    }
   
    setTimeout(() => 
    {
      if(typeof this.editKaizen.lineID !== "undefined")
      {
        this.formLocation.controls['lineId'].setValue(this.editKaizen.lineID);
      }
      this.emitLocation();
    }, 2000);
    setTimeout(() => 
    {
      if(typeof this.editKaizen.costCenterID !== "undefined")
      {
        this.formLocation.controls['costCenterID'].setValue(this.editKaizen.costCenterID);
      }
    }, 2000);
  }

  changeCostCenter(e: any) {
    //var selectedCostCenter = this.costCenters[e.target.value];
    this.CreateKaizenLocation.costCenterName = this.costCenters.filter(x => x.costCenterID == e.target.value).map(x=>x.costCenterName).toString();
    this.CreateKaizenLocation.costCenterID = e.target.value;
    this.emitLocation();
    // if (this.editKaizen.costCenterName != selectedCostCenter.costCenterName) {
    //   this.reApprovalReq = true;
    // }
    // else {
    //   this.reApprovalReq = false;
    // }
  }
  changeSupportingCostCenter(e: any) {
    this.CreateKaizenLocation.supportingCostCenterID = e.target.value;
    this.emitLocation();
  }
  changeSupportingShop(e: any) {
    firstValueFrom(this.CostCenterService.getCostCenterByShopId(e.target.value)).then((data) => { this.filteredSupportingcostCenters = data?.data || []; });
    this.CreateKaizenLocation.supportingShopID = e.target.value;
    this.emitLocation();
  }
  changeSupportingLine(e: any) {
    this.formLocation.controls['supportingShopId'].setValue('');
    this.formLocation.controls['supportingCostCenterID'].setValue('');
    firstValueFrom(this.ShopService.getShopByLineId(e.target.value)).then((data) => { this.filteredSupportingShops = data?.data || [] });
    this.CreateKaizenLocation.supportingLineID = e.target.value;
    this.emitLocation();
  }
  changeSupportingCompany(e: any) {
    this.formLocation.controls['supportingLineId'].setValue('');
    this.formLocation.controls['supportingShopId'].setValue('');
    this.formLocation.controls['supportingCostCenterID'].setValue('');
    firstValueFrom(this.LineService.getLineByCompanyId(e.target.value)).then((data) => {this.filteredSupportingLines = data?.data || []; });
    this.CreateKaizenLocation.supportingCompanyID = e.target.value;
    this.emitLocation();
  }
  changeCompany(e: any) {
    this.formLocation.controls['lineId'].setValue('');
    this.formLocation.controls['costCenterID'].setValue('');
    this.formLocation.controls['modelId'].setValue('');
    this.shopControl.reset();
    this.selectedCompanyId = e.target.value;
    
    this.CreateKaizenLocation.companyID = e.target.value;
    firstValueFrom(this.ShopService.getShopByCompanyId(e.target.value)).then((data) => {
      this.shops = data?.data || [];
    });
    firstValueFrom(this.LineService.getNonSupportLineByCompanyId(e.target.value)).then((data) => {
      this.filteredLines = data?.data || [];
    });
    this.CreateKaizenLocation.lineID = 0;
    this.CreateKaizenLocation.companyName = '' + this.companies.find(x => x.companyID == e.target.value)?.companyName;
    if (this.editKaizen.companyID != e.target.value) {
      this.CreateKaizenLocation.locTabUpdateFlag = true;
    }
    this.emitLocation();
  }
  changeLine(e: any) {
    this.formLocation.controls['costCenterID'].setValue('');
    this.formLocation.controls['modelId'].setValue('');
    this.filteredVehicleModels = this.vehicleModel.filter(x => x.lineID == e.target.value);
    this.CreateKaizenLocation.lineID = e.target.value;
    this.CreateKaizenLocation.lineName = '' + this.lines.find(x => x.lineID == e.target.value)?.lineName;
    if (this.editKaizen.lineID != e.target.value) {
      this.CreateKaizenLocation.locTabUpdateFlag = true;
    }
    this.emitLocation();
    firstValueFrom(this.CostCenterService.getCostCenterByShopId(this.CreateKaizenLocation.shopID)).then((data) => 
    { 
      this.costCenters = data?.data || []; 
      this.filteredCostCenters = data?.data || []; 
    });
  }
  changeModelImpacted(e: any) {
    this.CreateKaizenLocation.vehicleModelID = e.target.value;
    this.CreateKaizenLocation.vehicleModel = '' + this.vehicleModel.find(x => x.vehicleModelID == e.target.value)?.modelName;
    if (this.editKaizen.vehicleModelID != e.target.value) {
      this.CreateKaizenLocation.locTabUpdateFlag = true;
    }
    this.emitLocation();
  }
  changekaizenImpactingModel(e: any) {
    this.selectedGLAccountImpactArea = e.target.options[e.target.options.selectedIndex].value;
    this.CreateKaizenLocation.kaizenImpactingModelID = e.target.value;
    this.CreateKaizenLocation.impactingModel = '' + this.kaizenImpactingModel.find(x => x.kaizenImpactingModelID == e.target.value)?.name;
    //subtract 1 from selected value to make it match the array kaizenImpactingModel index value
    if (this.CreateKaizenLocation.impactingModel.toLowerCase() == "by model") {
      this.formLocation.controls['modelId'].setValidators([Validators.required]);
      this.formLocation.controls['modelId'].enable();
    }
    else {
      this.formLocation.controls['modelId'].clearValidators();
      this.formLocation.controls['modelId'].disable();
      this.formLocation.controls['modelId'].setValue('');  
    }

    this.formLocation.controls['modelId'].updateValueAndValidity();
    if (this.editKaizen.kaizenImpactingModelID != e.target.value) {
      this.CreateKaizenLocation.locTabUpdateFlag = true;
    }
    this.emitLocation();
  }

  filter(val: string, filteredShops:string): Observable<Shop[]> 
  {
    return this.ShopService.getShopSearch(val, filteredShops, this.selectedCompanyId)
      .pipe(map(response => response.data.filter(option => 
      {
        return option.name.toLocaleLowerCase().indexOf(val.toLowerCase()) === 0
      }))
      )
  }
  emitLocation() {
    this.emitKaizenLocation.emit(this.CreateKaizenLocation);
   // console.log(this.CreateKaizenLocation);
  }
 
}